import './shared-store.mjs';
import { s as sharedStore } from '../../../../../../_virtual/shared-store.mjs';

var store = sharedStore.exports;

var shared = function (key, value) {
  return store[key] || (store[key] = value || {});
};

export { shared as default };
